export const forgotPasswordModalStyles = {
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},

	iconWrap: {
		marginBottom: '32px',
	},
	contentWrap: {},
	title: {
		textAlign: 'center',
	},
	description: {
		textAlign: 'center',
		color: 'var(--neutral-300)',
		fontSize: '16px',
		marginTop: '8px',
	},

	afterDescription: {
		textAlign: 'center',
		fontSize: '16px',
	},

	formWrap: {
		width: '100%',
	},

	fieldWrap: {
		marginBottom: '16px',
		'&:last-of-type': {
			marginBottom: '32px',
		},
	},

	btnWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '16px',
		width: '100%',
		maxWidth: '370px',
		marginTop: '32px',
	},
	btn: {
		width: '100%',
	},

	textWrap: {
		display: 'flex',
		gap: '4px',
		alignItems: 'flex-end',
		marginBottom: '32px',
	},
};
